import React from 'react';
import './site.css';

function Precos() {
  return (
    <section id="preco">
      <div className="section-header">
        <h2>Vídeos e Informativos</h2>
      </div>

      <div className="row g-4">
        <div className="col-lg-4 col-md-6">
          <div className="video-card">
            <div className="video-card-header">
              <h4>Produtos sem lactose</h4>
            </div>
            <div className="video-card-body">
              <iframe
                src="https://www.youtube.com/embed/Q-iXZPwvDSc"
                title="Produtos sem lactose"
                allowFullScreen
              />
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-6">
          <div className="video-card">
            <div className="video-card-header">
              <h4>Receita</h4>
            </div>
            <div className="video-card-body">
              <iframe
                src="https://www.youtube.com/embed/pCOydifkDcs"
                title="Receita"
                allowFullScreen
              />
            </div>
          </div>
        </div>

        <div className="col-lg-4 col-md-6">
          <div className="video-card">
            <div className="video-card-header">
              <h4>Homenagem</h4>
            </div>
            <div className="video-card-body">
              <iframe
                src="https://www.youtube.com/embed/0IYGEB1T6Ns"
                title="Homenagem"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Precos;